import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
import { msgGet, msgSave, msgUpdate } from '@/api/system/message';
import { useCommonDialog } from '@/component-create/utils/hooks';
import { renderMessageAdd } from './add';
import { renderMessageSearchForm } from './search';
import { createMessageTable } from './table';
import { MESSAGE_RECIPIENT } from "@/constant/system/code";
import DepartmentSelect from '@/views/components/DepartmentSelect.vue';
import UserSelector from '@/views/components/UserSelector.vue';
import { toast } from '@/utils/message';
import { isOnlyOne } from '@/utils/common';
import MessageContent from './MessageContent.vue';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Message',
  setup: function setup(__props) {
    var searchFormRef = ref();
    var tableRef = ref();
    var addRef = ref();
    var editRef = ref();
    var searchData = ref({});
    var editDialog = useCommonDialog('editDialog');
    var editFormData = ref({});
    var messageContentRef = ref();
    var table;
    onMounted(function () {
      var addForm = renderMessageAdd(addRef.value, function (formData) {
        msgSave(formData).then(function () {
          toast.success('保存成功');
          table.load(searchData.value);
          addForm.close();
        });
      });
      var search = renderMessageSearchForm(searchFormRef.value);
      search.onSearch = function (formData) {
        searchData.value = formData;
        table.load(formData);
      };
      search.onReset = function () {
        searchData.value = {};
        table.load({});
      };
      table = createMessageTable(tableRef.value, {
        rowEdit: function rowEdit(row) {
          editDialog.open();
          msgGet(row.id).then(function (res) {
            editFormData.value = _objectSpread({
              deptRecipients: [],
              userRecipients: []
            }, res.data);
          }).catch(function () {
            editDialog.close();
          });
        },
        rowShow: rowShow
      }, {
        addFn: function addFn() {
          addForm.open();
        },
        editFn: function editFn(rows) {
          if (isOnlyOne(rows)) {
            editDialog.open();
            msgGet(rows[0].id).then(function (res) {
              editFormData.value = _objectSpread({
                deptRecipients: [],
                userRecipients: []
              }, res.data);
            }).catch(function () {
              editDialog.close();
            });
          }
        }
      }, searchData);
    });
    function rowShow(row) {
      var _messageContentRef$va;
      (_messageContentRef$va = messageContentRef.value) === null || _messageContentRef$va === void 0 || _messageContentRef$va.open(row.id);
    }
    function update() {
      if (editFormData.value.recipient === MESSAGE_RECIPIENT.USER.CODE && (!editFormData.value.userRecipients || editFormData.value.userRecipients.length === 0)) {
        toast.warn('请选择接收用户');
        return;
      }
      if (editFormData.value.recipient === MESSAGE_RECIPIENT.DEPT.CODE && (!editFormData.value.deptRecipients || editFormData.value.deptRecipients.length === 0)) {
        toast.warn('请选择接收部门');
        return;
      }
      msgUpdate(editFormData.value).then(function () {
        toast.success('保存成功');
        cancel();
        table.load(searchData.value);
      });
    }
    function cancel() {
      editFormData.value = {};
      editDialog.close();
    }
    return function (_ctx, _cache) {
      var _component_ElInput = _resolveComponent("ElInput");
      var _component_ElFormItem = _resolveComponent("ElFormItem");
      var _component_ElCol = _resolveComponent("ElCol");
      var _component_ElRow = _resolveComponent("ElRow");
      var _component_XTinyMce = _resolveComponent("XTinyMce");
      var _component_XSelect = _resolveComponent("XSelect");
      var _component_ElRadio = _resolveComponent("ElRadio");
      var _component_ElRadioGroup = _resolveComponent("ElRadioGroup");
      var _component_ElForm = _resolveComponent("ElForm");
      var _component_ElButton = _resolveComponent("ElButton");
      var _component_XCommonDialog = _resolveComponent("XCommonDialog");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            ref_key: "searchFormRef",
            ref: searchFormRef
          }, null, 512), _createElementVNode("div", {
            style: {
              "height": "100%"
            },
            ref_key: "tableRef",
            ref: tableRef
          }, null, 512), _createElementVNode("div", {
            ref_key: "addRef",
            ref: addRef
          }, null, 512), _createElementVNode("div", {
            ref_key: "editRef",
            ref: editRef
          }, null, 512), _createVNode(_component_XCommonDialog, {
            ref_key: "editDialog",
            ref: editDialog
          }, {
            footer: _withCtx(function () {
              return [_createElementVNode("div", null, [_createVNode(_component_ElButton, {
                onClick: cancel
              }, {
                default: _withCtx(function () {
                  return _cache[10] || (_cache[10] = [_createTextVNode("取消")]);
                }),
                _: 1
              }), _createVNode(_component_ElButton, {
                type: "primary",
                onClick: update
              }, {
                default: _withCtx(function () {
                  return _cache[11] || (_cache[11] = [_createTextVNode("保存")]);
                }),
                _: 1
              })])];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_ElForm, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_ElRow, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_ElCol, {
                        span: 24
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_ElFormItem, {
                            label: "主题",
                            prop: "subject"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_ElInput, {
                                clearable: "",
                                maxlength: "256",
                                modelValue: _unref(editFormData).subject,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                                  return _unref(editFormData).subject = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_ElRow, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_ElCol, {
                        span: 24
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_ElFormItem, {
                            label: "内容",
                            prop: "content"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_XTinyMce, {
                                modelValue: _unref(editFormData).content,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                                  return _unref(editFormData).content = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_ElRow, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_ElCol, {
                        span: 24
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_ElFormItem, {
                            label: "类型",
                            prop: "type"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_XSelect, {
                                loader: "MESSAGE_TYPE",
                                modelValue: _unref(editFormData).type,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                                  return _unref(editFormData).type = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_ElRow, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_ElCol, {
                        span: 24
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_ElFormItem, {
                            label: "接收人",
                            prop: "recipient"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_ElRadioGroup, {
                                modelValue: _unref(editFormData).recipient,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                                  return _unref(editFormData).recipient = $event;
                                })
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_ElRadio, {
                                    label: _unref(MESSAGE_RECIPIENT).ALL.CODE
                                  }, {
                                    default: _withCtx(function () {
                                      return _cache[7] || (_cache[7] = [_createTextVNode("所有用户")]);
                                    }),
                                    _: 1
                                  }, 8, ["label"]), _createVNode(_component_ElRadio, {
                                    label: _unref(MESSAGE_RECIPIENT).DEPT.CODE
                                  }, {
                                    default: _withCtx(function () {
                                      return [_createElementVNode("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("span", {
                                        style: {
                                          "padding-right": "10px"
                                        }
                                      }, "指定部门", -1)), _unref(editFormData).recipient === _unref(MESSAGE_RECIPIENT).DEPT.CODE ? (_openBlock(), _createBlock(DepartmentSelect, {
                                        key: 0,
                                        modelValue: _unref(editFormData).deptRecipients,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                                          return _unref(editFormData).deptRecipients = $event;
                                        }),
                                        multiple: "",
                                        placeholder: "选择部门",
                                        style: {
                                          "width": "250px"
                                        }
                                      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])];
                                    }),
                                    _: 1
                                  }, 8, ["label"]), _createVNode(_component_ElRadio, {
                                    label: _unref(MESSAGE_RECIPIENT).USER.CODE
                                  }, {
                                    default: _withCtx(function () {
                                      return [_createElementVNode("div", _hoisted_2, [_cache[9] || (_cache[9] = _createElementVNode("span", {
                                        style: {
                                          "padding-right": "10px"
                                        }
                                      }, "指定用户", -1)), _unref(editFormData).recipient === _unref(MESSAGE_RECIPIENT).USER.CODE ? (_openBlock(), _createBlock(UserSelector, {
                                        key: 0,
                                        modelValue: _unref(editFormData).userRecipients,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                                          return _unref(editFormData).userRecipients = $event;
                                        }),
                                        multiple: "",
                                        placeholder: "选择用户",
                                        style: {
                                          "width": "250px"
                                        }
                                      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])];
                                    }),
                                    _: 1
                                  }, 8, ["label"])];
                                }),
                                _: 1
                              }, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_ElRow, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_ElCol, {
                        span: 24
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_ElFormItem, {
                            label: "备注",
                            prop: "remark"
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_ElInput, {
                                type: "textarea",
                                row: 3,
                                maxlength: "200",
                                showWordLimit: "",
                                modelValue: _unref(editFormData).remark,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                                  return _unref(editFormData).remark = $event;
                                })
                              }, null, 8, ["modelValue"])];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 512), _createVNode(MessageContent, {
            ref_key: "messageContentRef",
            ref: messageContentRef
          }, null, 512)];
        }),
        _: 1
      });
    };
  }
});